type ColorRGB = { r: number; g: number; b: number };

function rgbToHex(rgb: ColorRGB) {
  const componentToHex = (c: number) => {
    var hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  };
  return (
    '#' + componentToHex(rgb.r) + componentToHex(rgb.g) + componentToHex(rgb.b)
  );
}

const hexToRgb = (hex: string) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : {
        r: 0,
        g: 0,
        b: 0,
      };
};

const colorGradient = (value: number = 0, ...args: ColorRGB[]) => {
  const ratio = value * (args.length - 1); // calculate where in args the value is

  const colour1 = args[Math.floor(ratio)];
  const colour2 = args[Math.ceil(ratio)];
  const fade = ratio % 1;

  let gradient = {
    r: Math.floor(colour1.r + (colour2.r - colour1.r) * fade),
    g: Math.floor(colour1.g + (colour2.g - colour1.g) * fade),
    b: Math.floor(colour1.b + (colour2.b - colour1.b) * fade),
  };

  return 'rgb(' + gradient.r + ',' + gradient.g + ',' + gradient.b + ')';
};

export { rgbToHex, hexToRgb, colorGradient, ColorRGB };
